<template>
  <div v-if="featuredSection" class="xcontainer">
    <plugin-index
      action="getPluginsByFeaturedSectionHandle"
      :request-data="requestData"
      :disable-sorting="true"
    >
      <template #header>
        <h1 class="mt-0 mb-4">
          {{ featuredSection.title }}
        </h1>
      </template>
    </plugin-index>
  </div>
</template>

<script setup lang="ts">
  import {useRoute} from 'vue-router';
  import PluginIndex from '../../../components/PluginIndex.vue';
  import {
    computed,
    definePageMeta,
    useAppStore,
    useAsyncData,
    usePluginIndexStore,
    usePluginStoreStore,
  } from '#imports';

  definePageMeta({
    layout: 'site',
  });

  const route = useRoute();

  const appStore = useAppStore();
  const pluginStoreStore = usePluginStoreStore();
  const pluginIndexStore = usePluginIndexStore();

  const featuredSection = computed(() => pluginStoreStore.featuredSection);
  const requestData = computed(() => {
    return {
      featuredSectionHandle: route.params.id,
    };
  });

  await useAsyncData(async () => {
    await pluginStoreStore
      .getFeaturedSectionByHandle(route.params.id)
      .then(() => {
        const featuredSection = pluginStoreStore.featuredSection;

        appStore.updatePageMeta({
          title: featuredSection.title,
          description: featuredSection.description,
        });
      });

    await pluginIndexStore
      .getPluginsByFeaturedSectionHandle({
        featuredSectionHandle: route.params.id,
      })
      .catch((thrown) => {
        throw createError({message: thrown});
      });
  });
</script>
